module.exports = __webpack_public_path__ + "media/images/icons/SVG/033-3d846638b12e951539897c0e129158b9.svg";